//TODO: add a valid key for the API
// const googleApiKey = 'AIzaSyBb3BPQBOFWDa4hYWp4ls4DAcwOJQtkKj0'

export const loadApi = new Promise<typeof google.maps>((resolve, reject) => {
    if ('google' in window) {
      resolve(google.maps)
    }
    const gMapApiScript = document.getElementById(`gmapapi`);
    if (!gMapApiScript) {
      const APIKEY = window['Baloise']['gmapKey'] ? window['Baloise']['gmapKey'] : ''
      const script = document.createElement('script');
      const gmapId = window['Baloise']['gmapId']
        ? `&client=${window['Baloise']['gmapId']}`
        : `&key=${APIKEY}`;
      script.async = true
      script.defer = true
      script.id = `gmapapi`
      script.onerror = reject
      script.onload = () => resolve(google.maps)
      script.src = `https://maps.googleapis.com/maps/api/js?libraries=places,geometry${gmapId}&callback=Function.prototype`
      document.head.appendChild(script)
    }
  }
)

